import { useState } from 'react';

import { EditIcon } from 'lucide-react';
import { proxy, useSnapshot } from 'valtio';

import { authState } from '../../../../services/state/auth-state.jsx';

import { AlertDialog, AlertDialogContent } from '../../../ui/alert-dialog.jsx';
import { Button } from '../../../ui/button.jsx';
import { FormAccountActionValidateOtp } from '../forms/form-account-action-validate-otp.jsx';
import { FormAccountActionValidatePassword } from '../forms/form-account-action-validate-password.jsx';
import { FormCustomerActionNewEmail } from '../forms/form-customer-action-new-email.jsx';

export const dialogCustomerUpdateEmailState = proxy({
  step: 1,
});

export const DialogCustomerUpdateEmail = () => {
  const { user } = useSnapshot(authState);
  const { step } = useSnapshot(dialogCustomerUpdateEmailState);

  const [open, setOpen] = useState(false);

  return (
    <>
      <div className="flex h-[46px] w-full items-center justify-between rounded-2xl border border-input border-portal-foreground !bg-background px-3 py-2 text-sm ring-offset-background">
        <div className="truncate">{user.email}</div>
        <Button
          variant="ghost"
          className="hidden h-auto p-1.5 md:block"
          onClick={() => setOpen(true)}
        >
          <EditIcon className="size-4" />
        </Button>
      </div>

      <Button
        variant="link"
        className="flex h-auto p-1.5 md:hidden"
        onClick={() => setOpen(true)}
      >
        <EditIcon className="size-4" /> Editar E-mail
      </Button>

      <AlertDialog
        open={open}
        onOpenChange={(open) => {
          if (!open) {
            dialogCustomerUpdateEmailState.step = 1;
          }

          setOpen(open);
        }}
      >
        <AlertDialogContent>
          {step === 1 && (
            <FormAccountActionValidatePassword
              actionTitle="Editar E-mail"
              onFormSuccess={() => {
                dialogCustomerUpdateEmailState.step = 2;
              }}
            />
          )}
          {step === 2 && (
            <FormAccountActionValidateOtp
              actionTitle="Editar E-mail"
              verifyEndpoint="/auth/update-email/verify-otp"
              sendOtpEndpoint="/auth/update-email/otp"
              onFormSuccess={() => {
                dialogCustomerUpdateEmailState.step = 3;
              }}
            />
          )}
          {step === 3 && <FormCustomerActionNewEmail />}
        </AlertDialogContent>
      </AlertDialog>
    </>
  );
};
